<template>
    <div >
       <v-app-bar color="white" >
            <v-toolbar-title :style="$vuetify.breakpoint.name =='lg'? 'padding-left:3.6%': $vuetify.breakpoint.name =='xl' ?'padding-left:4.5%':'' " 
        >
                <v-img  height="55px" contain  src="../../assets/images/logo.svg">
                </v-img>
            </v-toolbar-title>
             <v-spacer></v-spacer>
       <v-btn outlined  rounded color="yellow" style="text-transform:none"  >
        <span style="color:black">Seller Portal</span>
      </v-btn>
      <Accountmenu/>
       </v-app-bar>
    </div>
</template>
<script>
import Accountmenu from "./accountMenu.vue"
export default {
  components:
  {
    Accountmenu,
  }
  
}
</script>